// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodAllergenId } from './FoodAllergen';
import { invProductId } from './InvProduct';
import { z } from 'zod';
export const foodIngredientAllergenId = (z.number());
export const foodIngredientAllergen = z.object({
    id: foodIngredientAllergenId,
    allergen_id: foodAllergenId,
    product_id: invProductId,
});
export const foodIngredientAllergenInitializer = z.object({
    id: foodIngredientAllergenId.optional(),
    allergen_id: foodAllergenId,
    product_id: invProductId,
});
export const foodIngredientAllergenMutator = z.object({
    id: foodIngredientAllergenId.optional(),
    allergen_id: foodAllergenId.optional(),
    product_id: invProductId.optional(),
});
//# sourceMappingURL=FoodIngredientAllergen.js.map